import { recordAccessEvent } from "./accessTracking";
import { getShareAttribution, makeVideoShareUrl, newShareId, ShareSource } from "./shareAttribution";

export type ShareMethod = "clipboard" | "clipboard_fallback" | "system" | "web" | "email" | "print";
export type ShareResult = "copied" | "system_handoff" | "window_requested" | "email_requested" | "print_requested" | "cancelled" | "failed";
type ShareVideo = { id: string; title: string };

let landingRecorded = false;
export function recordShareLanding() {
  const attribution = getShareAttribution();
  if (!attribution || landingRecorded) return;
  landingRecorded = true;
  void recordAccessEvent({ event: "share_landing", page: "share-link-entry", videoId: attribution.videoId,
    clientEventId: `${attribution.landingId}:landing` }, null);
}

export function recordShareOpen(video: ShareVideo) {
  void recordAccessEvent({ event: "share_open", videoId: video.id, videoTitle: video.title,
    clientEventId: `${newShareId()}:open` }, null);
}

export function beginShare(video: ShareVideo, source: ShareSource, method: ShareMethod) {
  const shareId = newShareId();
  const url = makeVideoShareUrl(video.id, typeof window === "undefined" ? undefined : window.location?.href, source, shareId);
  const fields = { videoId: video.id, videoTitle: video.title, shareId, shareSource: source, shareMethod: method };
  // Analytics must not be awaited: clipboard/system share/window.open need the
  // original user activation and must work even if tracking is unavailable.
  void recordAccessEvent({ ...fields, event: "share_click", clientEventId: `${shareId}:click` }, null);
  let finished = false;
  return { url, message: `${video.title}\n${url}`, finish(result: ShareResult, resultMethod = method) {
    if (finished) return;
    finished = true;
    void recordAccessEvent({ ...fields, shareMethod: resultMethod, event: "share_result",
      shareResult: result, clientEventId: `${shareId}:result` }, null);
  } };
}
